const monthsArray = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const formatСhatDate = (dateString: string, withTime?: boolean) => {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = monthsArray[date.getMonth()];
  const year = `'${date.getFullYear().toString().slice(-2)}`;

  let formatedDate = `${day} ${month} ${year}`;

  if (withTime) {
    formatedDate = `${date.getHours().toString().padStart(2, '0')}:${date
      .getMinutes()
      .toString()
      .padStart(2, '0')}, ${formatedDate}`;
  }

  return formatedDate;
};

export default formatСhatDate;
